module.exports = __webpack_public_path__ + "static/media/beer_icon_green.a94a49fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/beer_icon_green.png
// module id = 91
// module chunks = 0